import { SESSION_MGMT_DOMAIN } from 'core/constants/endpoints'

/**
 * Interface for the data about the leads to be tracked.
 */
export interface LeadData {
  // The basic details of the lead
  firstName: string
  gender?: 'MALE' | 'FEMALE'
  dateOfBirth: string
  emailAddress: string
  phoneNumber: string
  /** Boolean value indicating whether to include spouse */
  includeSpouse: boolean
  /** The details of the spouse, if any */
  spouseDetails: {
    gender?: 'MALE' | 'FEMALE'
    dateOfBirth?: string
  }
  /** Boolean value indicating whether to include child */
  includeChild: boolean
  /** The details of the children, if any */
  children: Array<{
    gender?: 'MALE' | 'FEMALE'
    dateOfBirth?: string
  }>
  /** Jornaya LeadiD token used for TCPA auditing */
  jornayaLeadId: string
  /** User's ZIP code */
  zip: string
  /** User's 2-char state abbreviation */
  state: string
  /** User's county name */
  county: string
}

/**
 * This function sends a POST request to track abandoned leads.
 * @param leadData - The data about the leads to be tracked got from census page.
 * @param timeout - The timeout for the request in milliseconds. If not provided, the request will not have a timeout.
 * @throws Will throw an error if the response status is not between 200 and 299.
 */
export default async function trackLead(
  leadData: LeadData,
  timeout?: number
): Promise<void> {
  const url = `${SESSION_MGMT_DOMAIN}/api/v1/abandoned-lead`

  const options: RequestInit = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(leadData)
  }

  if (timeout) {
    options.signal = AbortSignal.timeout(timeout)
  }

  const response = await fetch(url, options)

  if (!(response.status >= 200 && response.status < 300)) {
    throw new Error(`Request failed with status ${response.status}`)
  }
}
